

import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data () {
return {

}
},
methods: {
goBack(){
this.$router.go(-1)
},
register:function(){

}
}
}



// WEBPACK FOOTER //
// ./src/views/auth/law.vue